var render = function render() {
  var _vm = this,
      _c = _vm._self._c;return _c('div', [_c('resource-cloud-selection-dialog', { attrs: { "visible": _vm.visible, "resource-type-id": _vm.category.res_type || 0, "query": _vm.query, "formItem": _vm.formItem, "mutiple": false }, on: { "update:visible": function updateVisible($event) {
        _vm.visible = $event;
      }, "submit": _vm.handleSubmit } }), _vm._v(" "), _c('cropper-dialog', { ref: "cropper-dialog", attrs: { "visible": _vm.cropperDialogVisible, "cropper": _vm.cropper, "uploadRequest": _vm.uploadFile }, on: { "update:visible": function updateVisible($event) {
        _vm.cropperDialogVisible = $event;
      }, "upload-success": _vm.handleUploadSuccess } })], 1);
};
var staticRenderFns = [];

export { render, staticRenderFns };